import React from 'react';
import { articles } from '../../data/insights';
import { ArticleCard } from '../insights/ArticleCard';
import { ButtonLink } from '../ui/ButtonLink';
import { SectionHeading } from '../ui/SectionHeading';
export function HomeInsights() {
  return <section className="bg-porcelain py-24 lg:py-32" data-id="element-239" data-mp="9zgr1290shyq">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-240" data-mp="4y15za6uebgc">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-241" data-mp="50ndj9tqgqyk">
          <SectionHeading label="Insights & perspectives" title="Thinking on leadership and executive search" intro="The articles below are sample editorial content, shown to illustrate the insights hub until approved articles are published." data-id="element-242" data-mp="3dg73nzz3xt9e" />
          <ButtonLink to="/insights" variant="outline" arrow className="self-start lg:self-auto" data-id="element-243" data-mp="3ibw7ifi5twbi">
            All insights
          </ButtonLink>
        </div>
        <div className="mt-14 grid gap-x-8 gap-y-14 md:grid-cols-3" data-id="element-244" data-mp="xnrorwjf61is">
          {articles.slice(0, 3).map(a => <ArticleCard key={a.slug} article={a} data-id="element-245" data-mp="eckk0mp3fruk" />)}
        </div>
      </div>
    </section>;
}